module.exports = __webpack_public_path__ + "assets/img/left.496aca5f.png";